//
//
//
//
//
//
//

import tabbar from '../common/tabbar/tabbar';
  export default {
      name: "index",
    components:{
        tabbar
    },
    data(){
        return{
          tabbarData:[
            {
              txt:'教程',
              page:'/tutorial',
              img:'/static/images/jiaocheng.png',
              activeimg: "/static/images/jiaocheng-anxia.png"
            },
            {
              txt:'我的',
              page:'/mine',
              img:'/static/images/组 19.png',
              activeimg: "/static/images/wode@2x.png"
            },
          ]
        }
    },
    methods:{

    },
    created() {

    }
  }



// WEBPACK FOOTER //
// ./src/components/index/index.vue